module.exports = __webpack_public_path__ + "static/media/sneha.4f6920bb.jpg";